import React, { useState } from "react";

// import facebook from "../Images/";
// import instagram from "../Images/instagram.webp";
// import linkedin from "../Images/linkedin.webp";
// import twitter from "../Images/whiteTwitter.webp";
// import facebook1 from "../Images/icons/facebook-icon.png";
import facebook1 from "../Images/new/facebookNew.svg";
import instagram1 from "../Images/new/instagramNew.svg";
import linkedin1 from "../Images/new/linkedInNew.svg";
import twitter1 from "../Images/new/twitterNew.svg";
import youtube from "../Images/icons/youtube.png";
// import abcIT from "../Images/Itnew11.webp";
import abcIT from "../Images/footer logos/ITSW-logo.webp";
// import abcMartech from "../Images/abcMartech.webp";
import abcMartech from "../Images/footer logos/martech-logo.webp";
// import abcDev from "../Images/DevNew.webp";
import abcDev from "../Images/DevNew.webp";
// import abcFin from "../Images/FintechNew.webp";
import abcFin from "../Images/footer logos/Fintech-logo.webp";
// import abcEt from "../Images/abcET.webp";
import abcEt from "../Images/footer logos/ET-logo.webp";

import newlogo from "../Images/TALKCMO LOGO.webp";
import "../Styles/Footer.css";

import ModalComp from "./ModalComp";
import FootLogoComp from "./FootLogoComp";

export function FooterComp() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <footer className="footerPadding text-white">
        <div className="container container-max">
          <div className="row text-white mt-2">
            <div className="col-md-3 col-12 mt-3">
              <source srcSet={newlogo} type="image/webp" />
              <img
                className="FootLogo"
                src={abcDev}
                srcSet={`${newlogo} 150w, ${newlogo}@2x 300w`}
                sizes="(max-width: 150px) 150px, 300px"
                alt="TalkDev Logo"
                loading="lazy"
                width="150"
                height="60"
              />
              <div className="textdata">
                {/* <p className="mt-3 just-text text-white">
                  Acing the Science of Marketing Technologies.
                </p> */}
                <p className="mt-3 just-text text-white">
                  Talk Dev focuses on the latest trends, industry innovations,
                  and best practices in development. Featuring expert opinions,
                  industry interviews, and strategic guidance, Talk Dev helps
                  practitioners stay ahead in the game.
                </p>
                <div className="mt-3">
                  <a
                    className="fw-bold  text-decoration-none foot-text mt-3"
                    href="mailto: media@talkdev.com"
                  >
                    Media@TalkDev.com
                  </a>
                </div>
                <div className="mt-3">
                  <a
                    className="fw-bold foot-text text-decoration-none"
                    href="mailto: sales@talkdev.com"
                  >
                    Sales@TalkDev.com
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-12 mt-3">
              <h6 className="h5 fw-bold">About</h6>
              <a className="a-tag " href="/about">
                <p className="foot-text mt-3 borderB">About Us</p>
              </a>

              <a className="a-tag" href="/contact-us">
                <p className=" foot-text mt-3 borderB ">Contact Us</p>
              </a>

              <div className=" mt-3 borderB">
                {/* <p className="foot-text subclickbtn" onClick={handleShow}>
                  Subscribe
                </p> */}

                <a
                  href="/subscribe" // The page you want to open
                  target="_blank" // Opens in new tab
                  rel="noopener noreferrer" // Security best practice
                  className="foot-text subclickbtn"
                  style={{
                    cursor: "pointer",
                    textDecoration: "none",
                    display: "inline-block",
                  }}
                >
                  Subscribe
                </a>
              </div>

              <ModalComp show={show} handleClose={handleClose} />

              <a href="/sitemap" className="text-decoration-none ">
                {" "}
                <p className="foot-text mt-3 borderB">Sitemap</p>{" "}
              </a>
            </div>
            <div className="col-md-3 col-12 mt-3">
              <h6 className="h5 fw-bold">Policies</h6>

              <a className="a-tag" href="/privacy-policy">
                <p className="foot-text mt-3 borderB">Privacy Policy</p>
              </a>

              <a className="a-tag" href="/opt-out-form">
                <p className="foot-text mt-3 borderB">
                  Do Not Sell My Information
                </p>
              </a>
            </div>
            <div className="col-md-3 col-12 mt-3 followPadding">
              <h6 className="h5 fw-bold">Follow us</h6>

              <div className="d-flex mt-2">
                <div className="socialWrapper">
                  <div className="socialCard">
                    <a
                      href="https://www.facebook.com/talkdevnow/"
                      target="_blank"
                    >
                      <source srcSet={facebook1} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={facebook1}
                        height={30}
                        alt="facebook"
                        defer
                      />
                    </a>
                  </div>
                  <div className="socialCard">
                    <a
                      href="https://www.instagram.com/talkdevnow/"
                      target="_blank"
                    >
                      <source srcSet={instagram1} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={instagram1}
                        height={30}
                        alt="instagram"
                        loading="lazy"
                      />
                    </a>
                  </div>
                  <div className="socialCard">
                    <a href="https://x.com/talkdevnow" target="_blank">
                      <img
                        className="socialIcon"
                        src={twitter1}
                        height={30}
                        alt="twitter img"
                        loading="lazy"
                      />
                    </a>
                  </div>
                  <div className="socialCard">
                    <a
                      href="https://www.linkedin.com/company/talkdev"
                      target="_blank"
                    >
                      <source srcSet={linkedin1} type="image/webp" />
                      <img
                        className="socialIcon"
                        src={linkedin1}
                        height={32}
                        alt="linkedin"
                        loading="lazy"
                      />
                    </a>
                  </div>

                  {/* Krishna */}
                  <div className="socialCard">
                    <a
                      href="https://www.youtube.com/@talkdevnow"
                      target="_blank"
                    >
                      <picture>
                        <source srcSet={youtube} type="image/webp" />
                        <img
                          className="socialIcon"
                          src={youtube}
                          // width="120px"
                          // height="120"
                          alt="youtube"
                          loading="lazy"
                          style={{ height: "auto", padding: "0px" }}
                        />
                      </picture>
                    </a>
                  </div>
                  {/* Krishna */}
                </div>
              </div>
            </div>

            <div className="col-md-12 mt-3">
              <h6 className="text-center h5 fw-bold">Our Publications</h6>
            </div>

            <FootLogoComp />

            <div className="borderT mt-3 mb-1">
              <p className="mt-2 text-white " style={{ fontSize: " 13px" }}>
                An Imprint of OnDot ® Media © | All Rights Reserved |{" "}
                <a
                  href="/privacy-policy"
                  className="text-decoration-none hoverHead pRed"
                >
                  <span className="foot-text">Privacy Policy</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
